import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

interface CollapsibleSectionProps {
  icon: React.ReactNode;
  title: string;
  ariaLabel: string;
  children: React.ReactNode;
  defaultExpanded?: boolean;
  sectionClassName?: string;
}

export const CollapsibleSection = ({
  icon,
  title,
  ariaLabel,
  children,
  defaultExpanded = false,
  sectionClassName
}: CollapsibleSectionProps): React.ReactElement => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <section
      className={sectionClassName ?? "my-3 rounded-lg border border-border p-3"}
      aria-label={ariaLabel}
    >
      <button
        type="button"
        className="flex w-full items-center gap-2 rounded text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1"
        onClick={() => setIsExpanded((prev) => !prev)}
        aria-expanded={isExpanded}
      >
        {icon}
        <span className="flex-1 text-sm font-semibold text-foreground">
          {title}
        </span>
        {isExpanded ? (
          <ChevronUp
            className="size-4 flex-shrink-0 text-muted-foreground"
            aria-hidden="true"
          />
        ) : (
          <ChevronDown
            className="size-4 flex-shrink-0 text-muted-foreground"
            aria-hidden="true"
          />
        )}
      </button>

      {isExpanded && <div className="mt-3 space-y-2">{children}</div>}
    </section>
  );
};
